
export default function checklist( state = [], action = {} ){

	switch( action.type ){
		case 'GET_CH_DEPARTMENT':
			return action.checklist
		case 'SAVE_CHECKLIST':
			return action.checklist
		case 'GET_CHECKLIST':
			return action.checklist
		case 'DELETE_CHECKLIST':
			return action.checklist
		case 'UPDATE_CH_DEPARTMENT':
			return action.checklist
		case 'UPDATE_CHECKLIST':
			return action.checklist
		case 'UPDATE_CH_TYPE':
			return action.checklist
		default: return state;
	}
		
}




// WEBPACK FOOTER //
// ./src/store/reducers/check_list/checklist.reducer.js